import React from 'react';
import { DeleteForever } from '@mui/icons-material';
import { BiChevronDown, BiChevronUp } from 'react-icons/bi';
import './FromSchemeList.css';

const FromSchemeList = ({ 
    fromSchemeDetails, 
    fromSubheadsList, 
    screenType, 
    toggleNestedTable, 
    removeSubhead, 
    activity, 
    findSubActivitiesById, 
    fy_list, 
    expandedIndex, 
    totalAmount 
}) => {
    return (
        <div className="col-md-12">
            <div className="from-subhead-card">
                <div className="from-subhead-card__header">
                    <p className="from-subhead-card__title">From Subhead</p>
                    <div className="from-subhead-card__meta">
                        <span className="from-subhead-pill">
                            Records: {Array.isArray(fromSubheadsList) ? fromSubheadsList.length : 0}
                        </span>
                        <span className="from-subhead-pill">
                            Total: {totalAmount?.current ?? 0}
                        </span>
                    </div>
                </div>

                <div className="from-subhead-card__body">
                    <div className="table-responsive">
                        <table className="table from-subhead-table w-100">
                            <thead>
                                <tr>
                                    {fromSchemeDetails.is_activity_active == 1 && <th style={{ width: 44 }}> </th>}
                                    <th>Scheme Name</th>
                                    <th>Financial Year</th>
                                    <th>Subhead Name</th>
                                    {screenType != "View" && <th className="text-end">Subhead Balance</th>}
                                    <th className="text-end">Reappropriation Amount</th>
                                    {screenType != "View" && <th style={{ width: 90 }}>Action</th>}
                                </tr>
                            </thead>

                            <tbody>
                                {Array.isArray(fromSubheadsList) && fromSubheadsList.length > 0 ? (
                                    fromSubheadsList.map((e, index) => {
                                        const financial_year = fy_list.find(y => y.id == e.from_financial_id);
                                        const isRowExpanded = expandedIndex === index;

                                        return (
                                            <React.Fragment key={e.from_subhead_id}>
                                                <tr>
                                                    {fromSchemeDetails.is_activity_active == 1 && (
                                                        <td>
                                                            <span onClick={() => toggleNestedTable(index)} style={{ cursor: 'pointer' }}>
                                                                {isRowExpanded ? <BiChevronUp /> : <BiChevronDown />}
                                                            </span>
                                                        </td>
                                                    )}
                                                    <td>{fromSchemeDetails.scheme_name}</td>
                                                    <td>{financial_year?.start_year}-{financial_year?.end_year}</td>
                                                    <td>{e.subhead_name}</td>
                                                    {screenType != "View" && <td className="from-subhead-balance">{e.subhead_balance}</td>}
                                                    <td className="from-subhead-amount">{e.from_reappropriation_amount}</td>
                                                    {screenType != "View" && (
                                                        <td>
                                                            <button
                                                                type="button"
                                                                className="btn btn-outline-danger from-subhead-icon-btn"
                                                                onClick={(evt) => removeSubhead(index, 'from')}
                                                            >
                                                                <DeleteForever />
                                                            </button>
                                                        </td>
                                                    )}
                                                </tr>

                                                {fromSchemeDetails.is_activity_active == 1 && isRowExpanded && (
                                                    <tr>
                                                        <td colSpan={screenType != "View" ? 7 : 6}>
                                                            <div className="from-subhead-nested">
                                                                <table className="table">
                                                                    <thead>
                                                                        <tr>
                                                                            <th>Activity</th>
                                                                            <th>Subactivity</th>
                                                                            {screenType != "View" && <th>Available Balance</th>}
                                                                            <th className="text-end">Amount</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {e.activity && e.activity.length > 0 ? (
                                                                            e.activity.map((activityItem, idx) => (
                                                                                <tr key={idx}>
                                                                                    <td>
                                                                                        <select
                                                                                            className="form-control"
                                                                                            name="activity_id"
                                                                                            value={activityItem.activity_id}
                                                                                            disabled={true}
                                                                                        >
                                                                                            <option value="">---Select---</option>
                                                                                            {activity.map(a => (
                                                                                                <option key={a.id} value={a.id}>{a.activity}</option>
                                                                                            ))}
                                                                                        </select>
                                                                                    </td>
                                                                                    <td>
                                                                                        <select
                                                                                            className="form-control"
                                                                                            name="subactivity_id"
                                                                                            value={activityItem.subactivity_id}
                                                                                            disabled={true}
                                                                                        >
                                                                                            <option value="">---Select---</option>
                                                                                            {findSubActivitiesById(activityItem.activity_id).map(sa => (
                                                                                                <option key={sa.id} value={sa.id}>{sa.subactivity}</option>
                                                                                            ))}
                                                                                        </select>
                                                                                    </td>
                                                                                    {screenType != "View" && (
                                                                                        <td>
                                                                                            {e?.activity_budget && e?.activity_budget.length != 0 && e?.activity_budget.find(b =>
                                                                                                b.subhead_activity_id === activityItem.activity_id &&
                                                                                                b.subhead_subactivity_id === activityItem.subactivity_id
                                                                                            )?.budget}
                                                                                        </td>
                                                                                    )}
                                                                                    <td className="text-end fw-600">{activityItem?.budget}</td>
                                                                                </tr>
                                                                            ))
                                                                        ) : (
                                                                            <tr>
                                                                                <td colSpan={4} className="text-center text-muted">No Details Available</td>
                                                                            </tr>
                                                                        )}
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                )}
                                            </React.Fragment>
                                        );
                                    })
                                ) : (
                                    <tr>
                                        <td colSpan={screenType != "View" ? 7 : 6} className="text-center text-muted py-4">
                                            No records found
                                        </td>
                                    </tr>
                                )}
                            </tbody>

                            <tfoot>
                                <tr>
                                    <th colSpan={screenType != "View" ? 4 : 3}>Total Reappropriation Amount</th>
                                    <th className="text-end">{totalAmount.current}</th>
                                    {screenType != "View" && <th></th>}
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default FromSchemeList;